import Vue from 'vue'
import VueI18n from 'vue-i18n';

import En from '@/locale/lang/en';
import De from '@/locale/lang/de';
import Zh from '@/locale/lang/zh-cn';
import Fr from '@/locale/lang/fr';
import Es from '@/locale/lang/es';
import It from '@/locale/lang/it';
import Jp from '@/locale/lang/jp';
import Br from '@/locale/lang/br';
import { LANGUAGE } from '@/config/config';

// const messages = {
//   en: {
//     ...enLocale,
//     ...elementEnLocale
//   },
//   zh: {
//     ...zhLocale,
//     ...elementZhLocale
//   }
// }

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: LANGUAGE,
    messages: {
        'en': En,
        'de': De,
        'zh-cn': Zh,
        'fr': Fr,
        'es': Es,
        'it': It,
        'jp': Jp,
        'br': Br,
    }
})

export default i18n


//////////////////
// WEBPACK FOOTER
// ./src/locale/index.js
// module id = null
// module chunks = 